import { UploadVideo, SubText, Flex } from "@base-ui";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function VideoUploader(props) {
  var activeVideo = props.activeVideo,
    setActiveVideo = props.setActiveVideo;
  var uploadedVideo = (activeVideo === null || activeVideo === void 0 ? void 0 : activeVideo.name) && /*#__PURE__*/_jsxs(SubText, {
    mb: "10px",
    children: ["Vald video: ", activeVideo === null || activeVideo === void 0 ? void 0 : activeVideo.name]
  });
  return /*#__PURE__*/_jsxs(Flex.Column, {
    m: "15px 0",
    children: [uploadedVideo, /*#__PURE__*/_jsx(UploadVideo, {
      id: "upload-video-button",
      height: "170px",
      callback: function callback(files) {
        return files[0] && setActiveVideo(files[0]);
      }
    })]
  });
}